import React from 'react';
import { FoodServicePatchMutation } from '../graphql/mutations/FoodServicePatchMutation';
import { FoodServiceEditQuery } from '../graphql/query/FoodServiceEditQuery';
import { EntityEditFetcher } from '../components/EntityEditFetcher';
import typeIntro from '../static/introspection/FoodService.json';
import inputTypeIntro from '../static/introspection/FoodServicePatchInput.json';
import { EntityEditPage } from '../types/entities';
import { FoodService } from '../server-types';
import { ENTITY } from '../utils/entities';
import { graphqlQuery } from '../utils/graphql';
import { UserData } from '@food/auth';

export const FoodServiceEdit: React.FC<EntityEditPage<FoodService>> = ({
	id,
}) => (
	<UserData>
		{({ isInternal }) => (
			<EntityEditFetcher
				fetcher={graphqlQuery(FoodServiceEditQuery, { id })}
				mutation={FoodServicePatchMutation}
				entityName={ENTITY.FOOD_SERVICE}
				typeIntro={typeIntro}
				inputTypeIntro={inputTypeIntro}
				id={id}
				fields={[
					isInternal ? 'sfId' : null,
					'name',
					'logoMedia',
					'description',
					'descriptionIta',
					'descriptionLong',
					'descriptionLongIta',
					'pecEmail',
					'vatNumber',
					'website',
					'Country',
					'StateProvince',
					'postalCode',
					'city',
					'address1',
					'address2',
					'lat',
					'lng',
				]}
			/>
		)}
	</UserData>
);
